import { z } from "zod";

export const newsletterHistoryStatusSchema = z.enum(["scheduled", "sent", "some_failed", "all_failed"]);

export const newsletterRecipientErrorSchema = z.object({
  recipient: z.string(),
  error: z.string(),
});

export const newsletterRecipientsPayloadSchema = z.object({
  recipients: z.array(z.string()),
  errors: z.array(newsletterRecipientErrorSchema),
});

export const newsletterHistorySummarySchema = z.object({
  id: z.number(),
  subject: z.string(),
  status: newsletterHistoryStatusSchema,
  recipientCount: z.number(),
  errorCount: z.number(),
  createdAt: z.string(),
  sentAt: z.string().nullable().optional(),
  loginId: z.number(),
  operatorLabel: z.string().optional(),
});

export const newsletterHistoryListResponseSchema = z.object({
  items: z.array(newsletterHistorySummarySchema),
  count: z.number(),
});

export const newsletterHistoryDetailSchema = z.object({
  id: z.number(),
  subject: z.string(),
  status: newsletterHistoryStatusSchema,
  htmlSnapshot: z.string(),
  recipients: newsletterRecipientsPayloadSchema,
  createdAt: z.string(),
  sentAt: z.string().nullable().optional(),
  loginId: z.number(),
  operatorLabel: z.string().optional(),
});

export const newsletterHistorySearchRequestSchema = z.object({
  searchFieldValue: z.string().optional(),
  status: z.array(newsletterHistoryStatusSchema).optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  limit: z.number(),
  offset: z.number(),
  ordinamento: z.enum(["ASC", "DESC"]).optional(),
  ordinamentoCampo: z.enum(["CREATED_AT", "SENT_AT", "SUBJECT"]).optional(),
});

export const newsletterPublishResponseSchema = z.object({
  historyId: z.number(),
  status: newsletterHistoryStatusSchema,
  recipientCount: z.number(),
  errorCount: z.number(),
  scheduledAt: z.string().nullable().optional(),
});

export const parseNewsletterHistoryListResponse = (data) => newsletterHistoryListResponseSchema.parse(data);
export const parseNewsletterHistoryDetail = (data) => newsletterHistoryDetailSchema.parse(data);
export const parseNewsletterPublishResponse = (data) => newsletterPublishResponseSchema.parse(data);
